import React from 'react';
import PropTypes from 'prop-types';
import union from 'lodash.union';
import ReactQuill, { Quill } from 'react-quill'; // ES6

const editorDefaultOptions = {
  modules: {
    toolbar: [
      [{ size: ['small', false, 'large'] }],
      ['bold', 'italic', 'underline'],
      [{ align: [] }],
      [{ color: ['#1a171b', '#6d6e71'] }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['link'],
    ],
  },
};

const Wysiwyg = (props) => {
  const modules = Object.assign({}, editorDefaultOptions.modules);
  const textColors = union(editorDefaultOptions.modules.toolbar[3][0].color, props.textColors);
  modules.toolbar[3][0] = { color: textColors };

  return <ReactQuill style={{ margin: '10px 0' }} modules={modules} {...props} />;
};

Wysiwyg.propTypes = {
  textColors: PropTypes.array,
};

Wysiwyg.defaultProps = {
  textColors: [],
};

export default Wysiwyg;



// WEBPACK FOOTER //
// ./src/components/UIKit/Wysiwyg/index.js